import React from "react";
import {Columns, Heading, Modal, Section, Table} from "react-bulma-components";


export default function AdditionalInfoModal({data, show, setShow}){


    return (
        <Modal
            show={show}
            onClose={() => setShow(false)}
            closeOnBlur
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Additional Info</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Table size={"fullwidth"}>
                                <thead>
                                    <tr>
                                        <th>Customer</th>
                                        <th>Customer Charger</th>
                                        <th>Customer Charge</th>
                                        <th>Supplier</th>
                                        <th>Supplier Charge</th>
                                        <th>External Supplier</th>
                                        <th>External Supplier Charge</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{data.customer ? data.customer.display_name : ""}</td>
                                        <td>{data.department ? data.department.name : ""}</td>
                                        <td>{data.cost}</td>
                                        <td>{data.movement_performer ? data.movement_performer.name : ""}</td>
                                        <td>{data.internal_charge}</td>
                                        <td>{data.external_supplier ? data.external_supplier.display_name : ""}</td>
                                        <td>{data.external_supplier_charge}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )



}